<template>

    <div class="form-group">
        <label
            :for="'field-' + field.uuid"
            class="control-label"
            v-text="field.label"
        ></label>

        <textarea
            type="text"
            class="form-control"
            :id="'field-' + field.uuid"
            @input="$emit('input', $event.target.value)"
            v-text="value"
        />
    </div>

</template>

<script>

export default {

    name:'ContactformTypesTextareatype',

    props: {
        field: {
            type:Object,
            required:true,
        },

        value: {
            required:true,
        },
    },
}

</script>
